export default __webpack_public_path__ + "static/1-412b8c5df134feb7a3799c4459b9843b.png";